import React, { useEffect, useState } from 'react';

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const lastDismissed = localStorage.getItem('pwaPromptDismissed');
    if (lastDismissed && Date.now() - parseInt(lastDismissed) < 7 * 24 * 60 * 60 * 1000) return;
    if (window.matchMedia('(display-mode: standalone)').matches) return;

    const ios = /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
    if (ios) {
      setIsIOS(true);
      setTimeout(() => setShow(true), 4000);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setTimeout(() => setShow(true), 4000);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      setDeferredPrompt(null);
    }
    setShow(false);
  };

  const handleDismiss = () => {
    localStorage.setItem('pwaPromptDismissed', Date.now().toString());
    setShow(false);
  };

  if (!show) return null;

  return (
    <>
      <style>{`
        @keyframes slideUp {
          from { transform: translateX(-50%) translateY(120px); opacity: 0; }
          to   { transform: translateX(-50%) translateY(0);    opacity: 1; }
        }
      `}</style>
      <div style={{
        position: 'fixed', bottom: '24px', left: '50%',
        transform: 'translateX(-50%)',
        width: 'calc(100% - 40px)', maxWidth: '420px',
        background: 'linear-gradient(135deg, #1a2332, #2d3748)',
        border: '1px solid #4a5568', borderRadius: '18px',
        padding: '18px 20px', zIndex: 9999,
        boxShadow: '0 12px 48px rgba(0,0,0,0.6)',
        animation: 'slideUp 0.4s cubic-bezier(0.16,1,0.3,1)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '14px' }}>
          <img src="/logo192.png" alt="logo" style={{ width: '48px', height: '48px', borderRadius: '12px', flexShrink: 0 }} />
          <div>
            <div style={{ color: 'white', fontWeight: '700', fontSize: '16px', lineHeight: 1.2 }}>
              Add MyGainLog to your home screen
            </div>
            <div style={{ color: '#a0aec0', fontSize: '13px', marginTop: '4px' }}>
              {isIOS
                ? 'Tap the share icon, then "Add to Home Screen"'
                : 'Get the full app experience — works offline too'}
            </div>
          </div>
        </div>
        {!isIOS && (
          <button
            onClick={handleInstall}
            style={{
              width: '100%', padding: '12px',
              background: 'linear-gradient(135deg, #f6993f, #ed8936)',
              border: 'none', borderRadius: '10px',
              color: 'white', fontWeight: '700', fontSize: '15px',
              cursor: 'pointer', marginBottom: '8px'
            }}
          >
            📲 Install App
          </button>
        )}
        <button
          onClick={handleDismiss}
          style={{
            width: '100%', padding: '10px',
            background: 'transparent', border: '1px solid #4a5568',
            borderRadius: '10px', color: '#718096',
            fontSize: '14px', cursor: 'pointer'
          }}
        >
          Not now
        </button>
      </div>
    </>
  );
};

export default PWAInstallPrompt;